<template>
  <section id="dashboard">
    <div class="container timeline-wrapper" v-if="dashboardLoader">
      <div class="timeline-item">
        <div class="animated-background">
          <div class="background-masker header-top"></div>
          <div class="background-masker header-second"></div>
          <div class="background-masker header-third"></div>
          <div class="background-masker header-four"></div>
          <div class="background-masker header-five"></div>
        </div>
      </div>
    </div>
    <div class="container dashboard-list" v-if="!dashboardLoader">
      <div class="row">
        <!-- <div :class="[full]" v-if="normal">
                    <div class="dashboard-board one bg-black">
                        <div class="board-title">
                            <p>карт хувь</p>
                            <span class="red-line3"></span>
                            <span class="red-line2"></span>
                            <span class="red-line1"></span>
                        </div>
                        <div class="board-number">
                            <p>{{users.cardPercent | percent}} </p>
                        </div>
                        <div class="last-total-price">
                            <p>{{users.last2yearPurchase | pricewithindexof}}</p>
                        </div>
                        <div class="icon-1"></div>
                        <div class="icon-2"></div>
                    </div>
                </div> -->
        <div :class="[full]" v-if="normal && bonus">
          <div
            class="dashboard-board two bg-blue"
            v-if="users.oldBonusBalance > 1"
          >
            <div class="board-title">
              <p>Хуучин бонус - {{ users.oldBonusBalance | pricewithindex }}</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-title">
              <p>
                Шинэ бонус -
                {{
                  (users.bonusBalance - users.oldBonusBalance) | pricewithindex
                }}
              </p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-4"></div>
          </div>

          <div class="dashboard-board two bg-blue" v-else>
            <div class="board-title">
              <p>Бонус</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.bonusBalance | pricewithindex }}</p>
            </div>
            <div class="last-total-price">
              <p>{{ users.cardPercent | percent }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-4"></div>
          </div>
        </div>
        <div :class="[full]" v-if="normal && !bonus">
          <div class="dashboard-board two bg-blue">
            <div class="board-title">
              <p>Бизнес Бонус</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.bonusBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-4"></div>
          </div>
        </div>
        <div
          :class="[full]"
          v-if="coin && this.$route.path != '/tokyo' && this.bonus"
        >
          <div class="dashboard-board three bg-grey">
            <div class="board-title">
              <p>Койн {{ users.embDayBalance | pricewithindex }}</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.embBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-6"></div>
          </div>
        </div>
        <div :class="[full]" v-if="this.$route.path == '/tokyo'">
          <div class="dashboard-board three" style="background: #ed3237">
            <div class="board-title">
              <p>{{ tokyoWord }}</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.lotteryCount }}</p>
            </div>
            <div class="icon-tokyo"></div>
            <div class="icon-6"></div>
          </div>
        </div>
        <div :class="[full]" v-if="upoint && this.bonus">
          <div class="dashboard-board four bg-yellow">
            <div class="board-title">
              <p>U-POINT</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ upointBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-5"></div>
          </div>
        </div>

        <div :class="[full]" v-if="vip && this.bonus">
          <div class="dashboard-board four">
            <div class="board-title">
              <p>{{ memberWord }} {{ users.dvipBalance | pricewithindex }}</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.dvipSavedBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-5"></div>
          </div>
        </div>
        <div :class="[full]" v-if="itemBonus">
          <div class="dashboard-board one" style="background: #d9765f">
            <div class="board-title">
              <p>Барааны бонус</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.itemBonusBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-5"></div>
          </div>
        </div>
        <div :class="[full]" v-if="!this.bonus">
          <div class="dashboard-board three bg-grey">
            <div class="board-title">
              <p>Бэлтгэн нийлүүлэгчийн бонус</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.embBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-6"></div>
          </div>
        </div>
        <div :class="[full]" v-if="this.$route.path != '/tokyo' && !this.bonus">
          <div class="dashboard-board three bg-grey">
            <div class="board-title">
              <p>Бизнес гишүүнчлэлийн бонус</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.DVipBalance }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-6"></div>
          </div>
        </div>

        <!-- Ажилчдын бонус -->
        <div
          :class="[full]"
          v-if="bonus && this.$route.path != '/tokyo' && this.bonus"
        >
          <div class="dashboard-board four bg-black">
            <div class="board-title">
              <p>{{ empBonusWord }}</p>
              <span class="red-line3"></span>
              <span class="red-line2"></span>
              <span class="red-line1"></span>
            </div>
            <div class="board-number">
              <p>{{ users.empBonusBalance | pricewithindex }}</p>
            </div>
            <div class="icon-3"></div>
            <div class="icon-6"></div>
          </div>
        </div>

        <!-- Бизнес картын мэдээлэл -->
        <div class="col-md-3" v-if="business">
          <router-link tag="a" to="/CardBusiness" exact>
            <div class="dashboard-img" v-if="this.stringDate == 'Mon'">
              <img src="../../assets/Frame1.png" />
            </div>
            <div class="dashboard-img" v-else-if="this.stringDate == 'Tue'">
              <img src="../../assets/Frame2.png" />
            </div>
            <div class="dashboard-img" v-else-if="this.stringDate == 'Wed'">
              <img src="../../assets/Frame3.png" />
            </div>
            <div class="dashboard-img" v-else-if="this.stringDate == 'Thu'">
              <img src="../../assets/Frame3.png" />
            </div>
            <div class="dashboard-img" v-else-if="this.stringDate == 'Fri'">
              <img src="../../assets/Frame5.png" />
            </div>
            <div class="dashboard-img" v-else>
              <img src="../../assets/Frame6.png" />
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from "../../EventBus";

export default {
  data() {
    return {
      users: {},
      full: "col-md-3",
      coin: true,
      upoint: true,
      normal: true,
      vip: false,
      dashboardLoader: true,
      upointBalance: 0,
      memberWord: "Гишүүнчлэл карт",
      empBonusWord: "Журмын халаас",
      tokyoWord: "Нийт эрх",
      bonus: false,
      itemBonus: false,
      date: new Date(),
      stringDate: "",
      business: false,
    };
  },

  methods: {
    dashboard() {
      this.stringDate = this.date.toUTCString().slice(0, 3);
      // this.businessCardImage = '../assets/image/' + this.stringDate
      // TODO:
      // assets/image/cardFri
      // assets/image/cardMon
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
        return;
      }
      console.log(user, "USER");
      var cardHolderInfId = user.cardHolderInfId;
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            if (results.isEmployee === 0) {
              this.coin = false;
              this.full = "col-md-3";
            }
            if (results.isDVIP === 1) {
              this.vip = true;
              this.full = "col-md-3";
            }
            if (results.CartType === "Bonus") {
              this.bonus = true;
            }
            if (results.CartType === "Business") {
              this.business = true;
            }
            if (results.itemBonusBalance > 0) {
              this.itemBonus = true;
            }
            this.dashboardLoader = false;
            this.users = results;
          }
        })
        .catch(() => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
      this.$bonusApi
        .post(
          "/bonus-card/upoint/card",
          {
            locationKey: 200805130000000001,
            posKey: 1,
            systemId: "BONUS",
            data: {
              card_number: cardHolderInfId,
              mobile: "",
              pin_code: "NominApproved",
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.result === 0) this.upointBalance = result.balance;
          else this.upointBalance = 0;
        })
        .catch(() => {
          this.upointBalance = 0;
        });
    },
    getWindowWidth() {
      var windowWidth = document.documentElement.clientWidth;
      if (windowWidth <= 980) {
        this.memberWord = "Г.Карт";
        this.empBonusWord = "Ж.Халаас";
        this.tokyoWord = "Нийт эрх";
      } else {
        this.memberWord = "Гишүүнчлэл Карт";
        this.empBonusWord = "Журмын Халаас";
        this.tokyoWord = "НИЙТ СУГАЛААНЫ ЭРХ";
      }
    },
  },
  created() {
    this.dashboard();
    EventBus.$on("refreshDashboard", this.dashboard);
    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
  },
};
</script>

<style>
[class*="col-"]:nth-child(n + 5) {
  margin-top: 10px;
}

#dashboard {
  margin-top: 30px;
  padding-top: 30px;
}
.dashboard-board {
  width: 100%;
  border-radius: 10px;
  padding: 20px;
  /* box-shadow: 0px 2px 8px 0 rgba(0, 0, 0, 0.2); */
  background-image: linear-gradient(to bottom, #1660ab, #1660ab),
    linear-gradient(to top, #1660ab, #3482d0);
  height: 80px;
  display: flex;
  flex-direction: column;
}
.dashboard-img {
  border-radius: 10px;
  height: 80px;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.dashboard-img img {
  width: 100%;
  height: 100%;
}

.dashboard-board.bg-black {
  background: #0c0c0c;
}
.dashboard-board.bg-blue {
  background: #1660ab;
}
.dashboard-board.bg-grey {
  background: #92919f;
}
.dashboard-board.bg-yellow {
  background: #f7941d;
}
.dashboard-board div {
  flex: 1;
}
.dashboard-board .board-title {
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.dashboard-board .board-title .memberNumber {
  position: absolute;
  right: 0;
  top: 15px;
}
.dashboard-board .board-title p {
  position: relative;
}
/* .dashboard-board .board-title p::after{
    position: absolute;
    content:'';
    width:4%;
    height: 2px;
    background: red;
    left:0;
    top:20px;
} */
.dashboard-board .board-number {
  color: #fff;
  height: 100%;
  word-break: break-all;
  display: flex;
  justify-content: flex-end;
  margin-top: -18px;
}
.dashboard-board .board-number p {
  padding: 0;
  margin: 0;
  font-weight: 300;
  font-size: 30px;
  line-height: 1.25;
}
.dashboard-board {
  position: relative;
}
.dashboard-board .icon-1 {
  position: absolute;
  top: 50%;
  width: 30px;
  height: 30px;
  background-image: url("../../assets/board/01.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.dashboard-board .icon-2 {
  position: absolute;
  top: 30%;
  right: 10%;
  width: 70px;
  height: 60px;
  background-image: url("../../assets/board/03.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.dashboard-board .icon-3 {
  position: absolute;
  top: 55%;
  left: 7%;
  width: 30px;
  height: 30px;
  background-image: url("../../assets/board/02.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.dashboard-board .icon-tokyo {
  position: absolute;
  top: 55%;
  left: 7%;
  width: 64px;
  height: 30px;
  background-image: url("../../assets/board/tokyo.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.dashboard-board .icon-4 {
  position: absolute;
  top: 30%;
  right: 0%;
  width: 80px;
  height: 50px;
  background-image: url("../../assets/board/04.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.dashboard-board .icon-5 {
  position: absolute;
  top: 10%;
  right: 0%;
  width: 90px;
  height: 80px;
  background-image: url("../../assets/board/06.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.dashboard-board .icon-6 {
  position: absolute;
  top: 0%;
  right: 2%;
  width: 90px;
  height: 80px;
  background-image: url("../../assets/board/05.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.background-masker {
  background: #fff;
  position: absolute;
}

/* Every thing below this is just positioning */

.background-masker.header-top {
  top: 0;
  left: 0px;
  right: 0;
  height: 10px;
  width: 100%;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
}
.background-masker.header-second {
  top: 15px;
  left: 0px;
  right: 0;
  height: 10px;
  width: 100%;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
}
.background-masker.header-third {
  top: 30px;
  left: 0px;
  right: 0;
  height: 10px;
  width: 100%;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
}
.background-masker.header-four {
  top: 45px;
  left: 0px;
  right: 0;
  height: 10px;
  width: 100%;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
}
.background-masker.header-five {
  top: 60px;
  left: 0px;
  right: 0;
  height: 10px;
  width: 100%;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.animated-background {
  background-size: 800px 104px;
  height: 70px;
  position: relative;
}
.timeline-item {
  background: #fff;
  border: 1px solid;
  border-color: #e5e6e9 #dfe0e4 #d0d1d5;
  border-radius: 3px;
  padding: 12px;
  margin: 0 auto;
  flex: 1;
  min-height: auto;
  border-radius: 10px;
}
.timeline-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.last-total-price {
  position: absolute;
  bottom: 5%;
}
.last-total-price p {
  margin-bottom: 0;
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: right;
  color: #ffffff;
}
@media only screen and (max-width: 570px) {
  .dashboard-board .board-title .memberNumber {
    bottom: 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .red-line3,
  .red-line2,
  .red-line1 {
    display: none;
  }
  .content {
    padding-top: 0px;
  }
  #dashboard {
    margin-top: 50px;
    padding: 0px;
  }
  .dashboard-list {
    max-width: 100% !important;
  }
  .dashboard-list .col-md-3 {
    width: 25%;
    padding: 0;
  }
  .dashboard-list .col-md-4 {
    width: 33.3%;
    padding: 0;
  }
  .dashboard-list .col-md-3::after {
    position: absolute;
    content: "";
    width: 2px;
    top: 0;
    right: 0px;
    height: 66px;
    opacity: 0.1;
    background-color: #ffffff;
  }
  .dashboard-list .col-md-4::after {
    position: absolute;
    content: "";
    width: 2px;
    top: 0;
    right: 0px;
    height: 66px;
    opacity: 0.1;
    background-color: #ffffff;
  }

  .dashboard-board .board-title {
    height: 9px;
    margin-top: 19px;
  }
  .dashboard-board .board-title p {
    margin-left: 6px;
    margin-bottom: 0;
    font-size: 10px;
    height: 9px;
    color: rgba(255, 255, 255, 0.5);
  }
  .dashboard-board .board-title p::after {
    display: none;
  }
  .dashboard-board .board-number {
    justify-content: flex-start;
    margin-top: 6px;
    height: 14px;
  }
  .dashboard-board .icon-2,
  .dashboard-board .icon-4,
  .dashboard-board .icon-6,
  .dashboard-board .icon-5 {
    display: none;
  }
  .dashboard-board .icon-1 {
    top: 27px;
    width: 24px;
    height: 24px;
    right: 11px;
  }
  .dashboard-board .icon-3 {
    top: 21px;
    width: 24px;
    height: 31px;
    right: 9px;
    left: inherit;
  }
  .dashboard-board .board-number p {
    margin-left: 6px;
    font-size: 13px;
    margin-bottom: 0;
  }
  .dashboard-board {
    padding: 0;
    height: 66px;
    border-radius: 0;
    background-image: linear-gradient(
      to top,
      #1660ab,
      #1e68b4,
      #2671bd,
      #2d79c7,
      #3482d0
    );
  }
  .dashboard-board div {
    flex: inherit;
  }
}
@media screen and (max-width: 1000px) {
  .last-total-price {
    display: none;
  }
  .dashboard-board .icon-tokyo {
    display: none;
  }
}
@media screen and (max-width: 1000px) and (min-width: 768px) {
  .dashboard-board .board-number p {
    font-size: 20px;
  }
  .dashboard-board .board-number {
    justify-content: flex-start;
  }
  .dashboard-list .col-md-3 {
    padding-right: 7px;
    padding-left: 7px;
  }
}
.red-line3 {
  width: 12px;
  margin-top: 2px;
  height: 1px;
  background-color: #ed3237;
  position: absolute;
  top: 45%;
}
.red-line2 {
  width: 6px;
  margin-top: 2px;
  height: 1px;
  background-color: #ed3237;
  position: absolute;
  top: 50%;
}
.red-line1 {
  width: 3px;
  margin-top: 2px;
  height: 1px;
  background-color: #ed3237;
  position: absolute;
  top: 57%;
}
</style>
